import React from 'react'

import { Outlet } from 'react-router-dom'
import { OutletWrapper } from '@base'

const AdminUnderwriting = () => {
	return (
		<OutletWrapper>
			<Outlet />
		</OutletWrapper>
	)
}

export default AdminUnderwriting
